import { getSessionStorageItem, setSessionStorageItem } from 'utils/storage-utils';
import { PRESAVE_PARAMS } from 'consts/flow-constants';
import { LOGIN_TYPES } from 'consts/login-constants';

import { AuthorizationFormProps } from 'pages/auth-sign-in-page/components/authorization-form';

import { type UniCreditOtpFormProps } from 'web-ui-kit/dist/uni-credit-otp-form';
import { type UniCreditScratchCardProps } from 'web-ui-kit/dist/uni-credit-scratch-card';
import { type BankAccountFormProps } from 'components/bank-account-form';
import { type SecureAnswersFormProps } from 'pages/recover-password-step-3-page/components/secure-answers-form';
import { KcContextOTPExtenstion, KcContextScratchExtenstion, KcContext, KcRegisterContext } from 'types';
import { CreateLoginAndPasswordFormProps } from 'pages/registration-step-3-page/components/create-login-and-password-form';

export function getSignInPresavedProps(): Pick<AuthorizationFormProps, 'phone' | 'username' | 'onSubmit' | 'loginType'> {
  return {
    phone: (getSessionStorageItem(PRESAVE_PARAMS.ACCOUNT_PHONE)) || '',
    username: (getSessionStorageItem(PRESAVE_PARAMS.ACCOUNT_USERNAME)) || '',
    loginType: getSessionStorageItem(PRESAVE_PARAMS.LOGIN_TYPE) as LOGIN_TYPES,
    onSubmit: (e, loginType, { phone, username }) => {
      setSessionStorageItem(PRESAVE_PARAMS.LOGIN_TYPE, loginType);

      if (loginType === LOGIN_TYPES.BY_PHONE) {
        setSessionStorageItem(PRESAVE_PARAMS.ACCOUNT_PHONE, phone);
      }

      if (loginType === LOGIN_TYPES.BY_USERNAME) {
        setSessionStorageItem(PRESAVE_PARAMS.ACCOUNT_USERNAME, username);
      }
    },
  };
}

export function getAndPresaveCreateLoginAndPassProps(kcContext: KcRegisterContext): Pick<CreateLoginAndPasswordFormProps, 'hasPhoneSwitcher'> {
  return {
    hasPhoneSwitcher: getAndPresaveBoolean(PRESAVE_PARAMS.REGISTER_HAS_PHONE_SWITCHER, kcContext.unique_main_mobile_phone),
  };
}

export function getAndPresavePhoneProps(kcContext: KcContextOTPExtenstion): Pick<UniCreditOtpFormProps, 'phoneLastDigits'> {
  return {
    phoneLastDigits: getAndPresaveString(PRESAVE_PARAMS.ACCOUNT_PHONE_LAST_DIGITS, kcContext.phone || ''),
  };
}

export function getAndPresaveAccountProps(): Pick<BankAccountFormProps, 'number' | 'onSubmit'> {
  return {
    number: getSessionStorageItem(PRESAVE_PARAMS.ACCOUNT_NUMBER) || '',
    onSubmit: (e, value) => {
      setSessionStorageItem(PRESAVE_PARAMS.ACCOUNT_NUMBER, value);
    },
  };
}

export function getAndPresaveSecureAnswersProps(kcContext: KcContext): Pick<SecureAnswersFormProps, 'secondAttempt'> {
  const hasError = Boolean(kcContext?.message?.summary);
  const secondAttempt = hasError ? true : undefined;

  return {
    secondAttempt: getAndPresaveBoolean(PRESAVE_PARAMS.SECOND_ATTEMPT, secondAttempt),
  };
}

export function getAndPresaveScratchProps(kcContext: KcContextScratchExtenstion): Pick<UniCreditScratchCardProps, 'card' | 'codeNumber' | 'availableKeysCount' | 'hiddenValues'> {
  const card = getAndPresaveString(PRESAVE_PARAMS.SCRATCH_CARD, kcContext.tan_set_id) || 'XXXXXXXXX';
  const codeNumber = getAndPresaveString(PRESAVE_PARAMS.SCRATCH_CODE_NUMBER, kcContext.tan_number) || 'XX';
  const availableKeysCount = parseInt(getAndPresaveString(PRESAVE_PARAMS.SCRATCH_AVAILABLE_KEYS_COUNT, kcContext.tan_key_count) || '0');

  return {
    card,
    codeNumber,
    availableKeysCount,
    hiddenValues: {
      tan_number: codeNumber,
    },
  };
}

function getAndPresaveString(prop: string, value: string) {
  if (value) {
    setSessionStorageItem(prop, value);

    return value;
  }

  return getSessionStorageItem(prop) || '';
}

function getAndPresaveBoolean(prop: string, value: boolean | undefined) {
  return Boolean(getAndPresaveString(prop, value !== undefined ? value.toString() : '') === 'true');
}
